import React, { useEffect, useState } from "react";
import { InputPadrao } from "./Base";
import VerifyEmail from "../utils/VerifyEmail";
// import { Container } from './styles';

function InputEmail({ value, setValue, ...props }) {
  const [erro, setErro] = useState(false);
  useEffect(() => {
    setErro(false);
  }, [value]);
  return (
    <div>
      <InputPadrao
        value={value}
        onChange={v => setValue(v.target.value)}
        style={{ border: erro && "1px solid red" }}
        onBlur={() => {
          if (!VerifyEmail(value) && !!value) {
            setErro(true);
          } else {
            setErro(false);
          }
        }}
      />
      {erro && <p style={{ color: "red" }}>Email invalido</p>}
    </div>
  );
}

export default InputEmail;
